<template>
  <b-container>
    <transition name="slide-fade">
      <b-row class="h-100">
        <b-col
          class="d-flex flex-column justify-content-center login-wrapper--right-form"
        >
          <div class="d-flex">
            <a href="https://www.tradiepass.com.au/">
              <b-img src="/img/logo.svg" fluid />
            </a>
          </div>

          <div class="mt-4">
            <h3 class="font-weight-bold">Registration account type</h3>
            <p class="mt-3 grey--text">
              Select an Account Type you are signing up for.
            </p>
          </div>

          <!-- Account Types -->
          <b-form-group v-slot="{ ariaDescribedby }">
            <div class="d-flex flex-column" style="gap: 8px">
              <b-form-radio
                v-for="accountType in accountTypes"
                :key="accountType.value"
                v-model="form.accountType"
                :value="accountType.value"
                :state="state.accountType"
                :aria-describedby="ariaDescribedby"
                class="mb-2 d-flex align-items-center tplogin"
              >
                <div
                  class="d-flex align-items-center"
                  style="margin-left: 12px; gap: 12px"
                >
                  <b-img
                    class="flex-shrink-0"
                    style="width: 56px; height: 56px; border-radius: 8px"
                    :src="accountType.logoUrl"
                  />
                  <span>
                    <b>{{ accountType.label }}:</b>
                    {{ accountType.description }}
                  </span>
                </div>
              </b-form-radio>
            </div>
            <b-form-invalid-feedback :state="state.accountType">
              Please select one Account Type in order to continue...
            </b-form-invalid-feedback>
          </b-form-group>

          <b-row class="px-3 mt-2">
            <b-col cols="12" lg="6" class="pr-lg-2">
              <b-button
                :to="{ name: 'auth.login-page', params: { isLogin: false } }"
                class="btn-outlined bg-white text-dark"
                block
              >
                Go back
              </b-button>
            </b-col>
            <b-col cols="12" lg="6" class="pl-lg-2">
              <b-button @click="onNext" variant="primary" block>
                <span>Next</span>
                <b-img
                  class="float-right"
                  src="/img/arrow-right.svg"
                  alt="arrow-right"
                  width="20"
                />
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </transition>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      previousForm: this.$route.params.previousForm,

      accountTypes: [
        {
          logoUrl: '/img/safety-hat.png',
          label: 'Tradie',
          value: 'tradie',
          description:
            'For individual workers to store and manager compliance tickets.',
        },
        {
          logoUrl: '/img/company-icon.png',
          label: 'Business',
          value: 'company',
          description:
            'For companies managing multiple tradies and compliance records.',
        },
      ],

      form: {
        accountType: null,
      },

      state: {
        accountType: null,
      },
    }
  },

  mounted() {
    if (this.previousForm === undefined)
      this.$router.replace({
        name: 'auth.login-page',
        params: { isLogin: false },
      })
  },

  methods: {
    onNext() {
      this.state.accountType = this.form.accountType !== null

      // console.log(this.form.accountType)
      // console.log(this.previousForm)

      switch (this.form.accountType) {
        case 'tradie':
          this.$router.push({
            name: 'auth.onboarding-tradie',
            params: { previousForm: this.previousForm },
          })
          break

        case 'company':
          this.$router.push({
            name: 'auth.onboarding-company',
            params: { previousForm: this.previousForm },
          })
          break
      }
    },
  },
}
</script>

<style lang="scss" scoped>
html,
body {
  height: 100%;
  margin: 0px;
}

.container {
  height: 100%;
}

/deep/ .col-form-label {
  font-weight: bold;
}

/deep/ .tplogin.custom-control {
  // ::before (ring) and ::after (inner dot) share identical top/left/width/height
  // in Bootstrap's default custom-radio styles, so the dot renders centered inside
  // the ring. They must be offset by the exact same amount here too, or the two
  // boxes drift apart and the dot appears off-center within the ring.
  label::before,
  label::after {
    top: 50% !important;
    transform: translateY(-50%);
  }
}
</style>
